import { Box, Divider } from "@mui/joy";
import { CalendarDays, Kanban } from "lucide-react";
import { useMemo, useState } from "react";

import { KanbanBoard } from "../../";
import CalendarV2 from "../../CalendarV2";
import { NavigationTabs } from "../../Project/components/ProjectDetails/NavigationTabs";
import { TaskActionComponent, TaskHeader } from "../../Tasks/components";
import { useJobExecution } from "../hooks";

interface ITaskComponent {
    activeTask: any;
    onComplete: any;
    actionProgress: any;
}

export default function TaskComponent(props: ITaskComponent) {
    const { activeTask, onComplete, actionProgress } = props;
    const { Id } = activeTask || {};
    const { tasks, refresh } = useJobExecution(activeTask);
    const [, setKanbanTasks] = useState<any>(null);

    const tabs = useMemo(
        () => [
            {
                name: "Board",
                icon: <Kanban size={18} />,
                component: (
                    <Box sx={{ px: { xs: 2, sm: 3 }, overflowX: "auto" }}>
                        <KanbanBoard setKanbanTasks={setKanbanTasks} />
                    </Box>
                ),
            },
            {
                name: "Calendar",
                icon: <CalendarDays size={18} />,
                component: (
                    <Box
                        sx={{
                            height: 640,
                            minHeight: 640,
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <CalendarV2 onEventsChange={refresh} />
                    </Box>
                ),
            },
        ],
        [refresh],
    );

    const isNextEligible =
        (tasks?.length ?? 0) > 0 &&
        tasks!.every((t: any) => t.Status === "COMPLETED");


    return (
        <Box
            sx={{
                mt: 1,
                px: { xs: 2, sm: 3 },
                animation: "fadeIn 0.5s ease-in-out",
                "@keyframes fadeIn": {
                    "0%": { opacity: 0 },
                    "100%": { opacity: 1 },
                },
            }}
        >
            <TaskHeader activeTask={activeTask} />
            <Divider />

            {/* Bleed full-width like the original Job Execution layout */}
            <Box mt={2} mx={{ xs: -2, sm: -3 }}>
                <NavigationTabs tabList={tabs} />
            </Box>

            <Box mt={4}>
                <Divider />
                <TaskActionComponent
                    taskName={activeTask?.Name || ""}
                    onComplete={onComplete}
                    actionProgress={actionProgress}
                    isNextEligible={isNextEligible}
                    taskId={Id || ""}
                />
            </Box>
        </Box>
    );
}
